import moment from "moment";

export const timeGreeting = () => {
  const d = new Date();
  const time = d.getHours();
  if (time < 12) {
    return "Good Morning";
  }
  if (time < 17) {
    return "Good Afternoon";
  } else {
    return "Good Evening";
  }
};

export const formatPhoneNumber = (str) => {
  if (!str) return str;
  var value = str.replace(/[^0-9+\s()-\u2013\u2014]/g, "");
  const digits = value.replace(/\D/g, "");
  if (digits.length === 10 && !value.startsWith("+") && !value.startsWith("00")) {
    return digits.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");
  }
  return value;
};

export const zipCodeFormatNumber = (str) => {
  return str.replace(/[^\d]/g, "").replace(/(\d{3})(\d{4})/, "$1-$2");
};

export const getMembersDateFormate = (date) => {
  const createdAt = new Date(date);
  var dd = createdAt.getDate();
  var yyyy = createdAt.getFullYear();
  const monthNames = [
    "Jan",
    "Feb",
    "March",
    "April",
    "May",
    "June",
    "July",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  if (dd < 10) {
    dd = "0" + dd;
  }
  return monthNames[createdAt.getMonth()] + " " + dd + ", " + yyyy;
};

export const onlyNumber = (event) => {
  const keycode = event.which;
  if (keycode === 13) {
  } else if (
    !(
      event.shiftKey === false &&
      (keycode === 8 ||
        keycode === 46 ||
        keycode === 37 ||
        keycode === 39 ||
        (keycode >= 48 && keycode <= 57))
    )
  )
    event.preventDefault();
};

// export const cardValidator = (cn) => {
//   let amex = new RegExp('^3[47][0-9]{13}$');
//   let visa = new RegExp('^4[0-9]{12}(?:[0-9]{3})?$');

//   let mastercard = new RegExp('^5[1-5][0-9]{14}$');
//   let mastercard2 = new RegExp('^2[2-7][0-9]{14}$');

//   let disco1 = new RegExp('^6011[0-9]{12}[0-9]*$');
//   let disco2 = new RegExp('^62[24568][0-9]{13}[0-9]*$');
//   let disco3 = new RegExp('^6[45][0-9]{14}[0-9]*$');

//   let diners = new RegExp('^3[0689][0-9]{12}[0-9]*$');
//   let jcb =  new RegExp('^35[0-9]{14}[0-9]*$');

//   console.log("visa.test(cn)",visa.test(cn));
//   if (visa.test(cn)) {
//     return 'VISA';
//   }
//   if (amex.test(cn)) {
//     return 'AMEX';
//   }
//   if (mastercard.test(cn) || mastercard2.test(cn)) {
//     return 'MASTERCARD';
//   }
//   if (disco1.test(cn) || disco2.test(cn) || disco3.test(cn)) {
//     return 'DISCOVER';
//   }
//   if (diners.test(cn)) {
//     return 'DINERS';
//   }
//   if (jcb.test(cn)) {
//     return 'JCB';
//   }
//   return undefined;
// }

export const dayPipe = (date) => {
  var DATE = moment(date);
  var REFERENCE = moment();
  var TODAY = REFERENCE.clone().startOf("day");
  var YESTERDAY = REFERENCE.clone().subtract(1, "days").startOf("day");

  // If you want only date from date object
  if (DATE.isSame(REFERENCE, "week")) {
    // Check if date is today, yesterday, weekday or others
    if (DATE.isSame(TODAY, "d")) return DATE.format("hh:mm A");
    else if (DATE.isSame(YESTERDAY, "d")) return "Yesterday";
    else return DATE.format("DD/MM/YYYY");
  }
};

export function setWithExpiry(key, value, ttl) {
  const item = {
    value: value,
    expiry: new Date().getTime() + ttl,
  };
  localStorage.setItem(key, JSON.stringify(item));
}

export function getWithExpiry(key) {
  const itemString = window.localStorage.getItem(key);
  if (!itemString) return null;

  const item = JSON.parse(itemString);
  const isExpired = new Date().getTime() > item.expiry;

  if (isExpired) {
    localStorage.removeItem(key);
    return null;
  }

  return item.value;
}

// export function isWithinHours(startTimeString, hours) {
//   const now = moment();
//   const startTime = moment(startTimeString);

//   // Special case: if hours is 0, check if start time is not in the future
//   if (hours === 0) {
//     console.log('Hours is 0 - checking if start time is not in future');
//     console.log('Start time:', startTimeString);
//     console.log('Current time:', now.format());
//     console.log('Is start time before or equal to now?', startTime.isSameOrBefore(now));

//     return startTime.isSameOrBefore(now);
//   }

//   // For other cases: deadline time = current time MINUS X hours
//   const deadlineTime = now.clone().subtract(hours, 'hours');

//   console.log('Start time:', startTimeString);
//   console.log('Hours to check:', hours);
//   console.log('Deadline time (hours ago from now):', deadlineTime.format());
//   console.log('Current time:', now.format());
//   console.log('Is start time after deadline?', startTime.isAfter(deadlineTime));

//   return startTime.isAfter(deadlineTime);
// }

export function isWithinHours(assignedId, startTimeString, hours) {
  let startTime = "";
  if (assignedId?.bankLesson && !assignedId?.cancelLesson) {
    // debugger
    startTime = moment(assignedId?.bankedExpDate);
  } else {
    startTime = moment(startTimeString);
  }
  const now = moment();

  // If the startTime is in the past, return false immediately
  if (startTime.isBefore(now)) {
    return true;
  }

  const diffInHours = startTime.diff(now, "hours", true); // true = get float value

  return diffInHours < hours;
}

export function getTooltipContent(info, currentUser, loginAsUser) {
  const role = currentUser?.role;
  const loginRole = loginAsUser?.role;

  const isElevatedUser =
    (role === "superadmin" &&
      ["admin", "subadmin", "teacher"].includes(loginRole)) ||
    (role === "admin" && (loginRole === "subadmin" || !loginAsUser)) ||
    (role === "subadmin" && !loginAsUser) ||
    role === "teacher" ||
    loginRole === "teacher";

  const props = info?.event?.extendedProps;
  const assignedId = props?.assignedId;
  const students = props?.studentAttendance || [];

  const classOrGroup = assignedId?.class_groupId?.name
    ? `Class/Group: ${assignedId?.class_groupId.name}<br />`
    : "";

  const lesson = props?.lesson_type?.name
    ? `Lesson: ${props?.lesson_type.name}<br />`
    : "";

  const room = props?.room?.roomName
    ? `Room: ${props?.room.roomName}<br />`
    : "";

  const cancelReason =
    (assignedId?.cancelLesson || assignedId?.bankLesson) &&
    assignedId?.cancelReason
      ? `Cancel reason: ${assignedId?.cancelReason}`
      : "";

  const cancelLine = cancelReason ? `${cancelReason}<br/>` : "";

  let studentContent = "";

  if (students.length > 1) {
    const names = students
      .map((s) => `${s?.studId?.first_name} ${s?.studId?.last_name}`)
      .join("<br/>");
    studentContent = `Students: ${names}<br/>`;
  } else if (students.length === 1) {
    const s = students[0];
    studentContent = `Student: ${s?.studId?.first_name} ${s?.studId?.last_name}<br/>${cancelLine}`;
  } else {
    studentContent = `Student: ${info?.event?.title}<br/>${cancelLine}`;
  }

  if (isElevatedUser) {
    return `${classOrGroup}${studentContent}${lesson}${room}`;
  }

  return `${lesson}${room}`;
}

export function getAdminId(loginAsUser, currentUser) {
  let adminId;

  // 🆕 Check if current user is a student or parent
  if (currentUser && (currentUser.role === "student" || currentUser.role === "parent")) {
    adminId = currentUser.adminId;
  }

  // 🧑‍💼 Check if admin (has highest precedence for admin cases)
  else if (
    (loginAsUser && loginAsUser.role === "admin") ||
    (!loginAsUser && currentUser && currentUser.role === "admin")
  ) {
    if (loginAsUser) {
      adminId = loginAsUser.userId;
    } else {
      adminId = currentUser.userId;
    }
  }

  // 🧑‍💼 Check if user is subadmin (either loginAsUser or currentUser)
  else if (
    (loginAsUser && loginAsUser.role === "subadmin") ||
    (currentUser && currentUser.role === "subadmin") ||
    (currentUser && currentUser.role === "superadmin")
  ) {
    if (loginAsUser) {
      adminId = loginAsUser.adminId;
    } else {
      adminId = currentUser.adminId;
    }
  }

  // 👤 Regular user
  else {
    if (loginAsUser) {
      adminId = loginAsUser.userId;
    } else {
      adminId = currentUser.userId;
    }
  }

  return adminId;
}
